var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSparkles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8335 1.33301C4.29374 1.33301 4.66684 1.7061 4.66684 2.16634V2.99968H5.50018C5.96042 2.99968 6.33351 3.37278 6.33351 3.83302C6.33351 4.29325 5.96042 4.66635 5.50018 4.66635H4.66684V5.49969C4.66684 5.95993 4.29374 6.33302 3.8335 6.33302C3.37327 6.33302 3.00017 5.95993 3.00017 5.49969V4.66635H2.16683C1.70659 4.66635 1.3335 4.29325 1.3335 3.83302C1.3335 3.37278 1.70659 2.99968 2.16683 2.99968H3.00017V2.16634C3.00017 1.7061 3.37327 1.33301 3.8335 1.33301ZM3.8335 9.66637C4.29374 9.66637 4.66684 10.0395 4.66684 10.4997V11.333H5.50018C5.96042 11.333 6.33351 11.7061 6.33351 12.1664C6.33351 12.6266 5.96042 12.9997 5.50018 12.9997H4.66684V13.833C4.66684 14.2933 4.29374 14.6664 3.8335 14.6664C3.37327 14.6664 3.00017 14.2933 3.00017 13.833V12.9997H2.16683C1.70659 12.9997 1.3335 12.6266 1.3335 12.1664C1.3335 11.7061 1.70659 11.333 2.16683 11.333H3.00017V10.4997C3.00017 10.0395 3.37327 9.66637 3.8335 9.66637Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66681 1.33301C10.0449 1.33301 10.3756 1.58758 10.4724 1.9531L11.4551 5.66546L14.2499 7.27787C14.5079 7.4267 14.6668 7.70188 14.6668 7.99969C14.6668 8.29751 14.5079 8.57269 14.2499 8.72152L11.4551 10.3339L10.4724 14.0463C10.3756 14.4118 10.0449 14.6664 9.66681 14.6664C9.2887 14.6664 8.95798 14.4118 8.86122 14.0463L7.87854 10.3339L5.08374 8.72152C4.82577 8.57269 4.66684 8.29751 4.66684 7.99969C4.66684 7.70188 4.82577 7.4267 5.08374 7.27787L7.87854 5.66547L8.86122 1.9531C8.95798 1.58758 9.2887 1.33301 9.66681 1.33301Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSparkles);
export default __webpack_public_path__ + "static/media/icon-sparkles.3e3fe120a2438af6f9d1c022adaf0944.svg";
export { ForwardRef as ReactComponent };